<div class="card mb-3">
	<div class="card-header d-flex justify-content-between align-items-center">
		<strong>{{'multi_tariff.categories.categories' | translate}}</strong>
		<button
			*ngIf="!readonly"
			type="button"
			class="btn btn-sm btn-primary"
			[disabled]="!ratesOptions.length"
			(click)="addCategory()"
		>
			{{'multi_tariff.categories.add_category' | translate}}
		</button>
	</div>

	<div class="card-body">
		<div class="border rounded p-3 mb-3" *ngFor="let category of categories; let categoryIndex = index">
			<div class="row align-items-center">
				<div class="col-md-1">
					<i
						role="button"
						class="fa"
						[ngClass]="{'fa-chevron-down': !category.show, 'fa-chevron-up': category.show}"
						(click)="toggleCategory(categoryIndex)"
					></i>
				</div>
				<label class="col-md-2"><strong>{{'multi_tariff.categories.name' | translate}} <span>*</span></strong></label>
				<div class="col-md-3">
					<input
						type="text"
						class="form-control"
						name="categoryName{{categoryIndex}}"
						maxlength="100"
						[disabled]="readonly"
						[ngClass]="{'border border-danger': categoryError(categoryIndex, 'name')}"
						[(ngModel)]="category.name"
						(ngModelChange)="emit()"
					/>
				</div>
				<label class="col-md-1"><strong>{{'multi_tariff.rates.rate' | translate}} <span>*</span></strong></label>
				<div class="col-md-3">
					<ng-select
						[items]="ratesOptions"
						bindLabel="label"
						bindValue="value"
						name="categoryRate{{categoryIndex}}"
						placeholder="{{'multi_tariff.rates.rates' | translate}}"
						[clearable]="false"
						[readonly]="readonly"
						[ngClass]="{'border border-danger': categoryError(categoryIndex, 'rate_id')}"
						[(ngModel)]="category.rate_id"
						(ngModelChange)="emit()"
					></ng-select>
				</div>
				<div class="col-md-2 text-right">
					<ng-container *ngIf="!readonly">
						<i
							*ngIf="categoryIndex < categories.length - 1"
							role="button"
							class="fa fa-arrow-down mr-2"
							title="{{'multi_tariff.categories.move_down' | translate}}"
							(click)="moveCategory(categoryIndex, 1)"
						></i>
						<i
							*ngIf="categoryIndex > 0"
							role="button"
							class="fa fa-arrow-up mr-2"
							title="{{'multi_tariff.categories.move_up' | translate}}"
							(click)="moveCategory(categoryIndex, -1)"
						></i>
					</ng-container>
					<button
						*ngIf="!readonly"
						type="button"
						class="btn btn-sm btn-link text-danger"
						(click)="removeCategory(categoryIndex)"
					>
						{{'g.delete' | translate}}
					</button>
				</div>
			</div>

			<div *ngIf="category.show" class="mt-3">
				<div class="alert alert-warning py-1" *ngIf="categoryError(categoryIndex, 'criteria')?.minOrMax">
					{{'multi_tariff.categories.criteria' | translate}}: {{'g.invalid_input' | translate}}
				</div>

				<table class="table table-sm">
					<thead>
						<tr>
							<th>{{'multi_tariff.categories.criteria_name' | translate}}</th>
							<th>{{'multi_tariff.categories.criteria_type' | translate}}</th>
							<th>{{'multi_tariff.categories.criteria_options' | translate}}</th>
							<th>{{'multi_tariff.categories.criteria_details' | translate}}</th>
							<th *ngIf="!readonly"></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let criterion of category.criteria; let criteriaIndex = index">
							<td style="width: 20%">
								<input
									type="text"
									class="form-control form-control-sm"
									name="criterionName{{categoryIndex}}_{{criteriaIndex}}"
									maxlength="100"
									[disabled]="readonly"
									[ngClass]="{'border border-danger': criterionError(categoryIndex, criteriaIndex, 'name')}"
									[(ngModel)]="criterion.name"
									(ngModelChange)="emit()"
								/>
							</td>
							<td style="width: 20%">
								<ng-select
									[items]="criteriaTypeOptions"
									bindLabel="label"
									bindValue="value"
									name="criterionType{{categoryIndex}}_{{criteriaIndex}}"
									placeholder="{{'multi_tariff.categories.criteria_type' | translate}}"
									[clearable]="false"
									[readonly]="readonly"
									[ngClass]="{'border border-danger': criterionError(categoryIndex, criteriaIndex, 'type')}"
									[(ngModel)]="criterion.type"
									(ngModelChange)="onCriteriaTypeChange(categoryIndex, criteriaIndex)"
								></ng-select>
							</td>
							<td [ngSwitch]="criterion.type">
								<!-- a period between two dates of the same year -->
								<div *ngSwitchCase="CRITERIA_TYPES.PERIOD_OF_YEAR" class="row no-gutters">
									<div class="col-6 pr-1">
										<div class="d-flex align-items-center">
											<label class="mb-0 mr-2 text-nowrap"><strong>{{'g.from' | translate}}</strong></label>
											<ng-select
												class="flex-grow-1 mr-1"
												[items]="monthOptions"
												bindLabel="label"
												bindValue="value"
												name="fromMonth{{categoryIndex}}_{{criteriaIndex}}"
												placeholder="{{'g.months_value' | translate}}"
												[clearable]="false"
												[readonly]="readonly"
												[ngClass]="{'border border-danger': detailError(categoryIndex, criteriaIndex, ['from','month'])}"
												[(ngModel)]="criterion.details.from.month"
												(ngModelChange)="resetDayForMonth(categoryIndex, criteriaIndex, 'from')"
											></ng-select>
											<ng-select
												class="flex-grow-1"
												[items]="monthsDays[criterion.details.from.month]"
												name="fromDay{{categoryIndex}}_{{criteriaIndex}}"
												placeholder="{{'g.days_value' | translate}}"
												[clearable]="false"
												[readonly]="readonly || !criterion.details.from.month"
												[ngClass]="{'border border-danger': detailError(categoryIndex, criteriaIndex, ['from','day'])}"
												[(ngModel)]="criterion.details.from.day"
												(ngModelChange)="emit()"
											></ng-select>
										</div>
									</div>
									<div class="col-6 pl-1">
										<div class="d-flex align-items-center">
											<label class="mb-0 mr-2 text-nowrap"><strong>{{'g.to' | translate}}</strong></label>
											<ng-select
												class="flex-grow-1 mr-1"
												[items]="monthOptions"
												bindLabel="label"
												bindValue="value"
												name="toMonth{{categoryIndex}}_{{criteriaIndex}}"
												placeholder="{{'g.months_value' | translate}}"
												[clearable]="false"
												[readonly]="readonly"
												[ngClass]="{'border border-danger': detailError(categoryIndex, criteriaIndex, ['to','month'])}"
												[(ngModel)]="criterion.details.to.month"
												(ngModelChange)="resetDayForMonth(categoryIndex, criteriaIndex, 'to')"
											></ng-select>
											<ng-select
												class="flex-grow-1"
												[items]="monthsDays[criterion.details.to.month]"
												name="toDay{{categoryIndex}}_{{criteriaIndex}}"
												placeholder="{{'g.days_value' | translate}}"
												[clearable]="false"
												[readonly]="readonly || !criterion.details.to.month"
												[ngClass]="{'border border-danger': detailError(categoryIndex, criteriaIndex, ['to','day'])}"
												[(ngModel)]="criterion.details.to.day"
												(ngModelChange)="emit()"
											></ng-select>
										</div>
									</div>
								</div>

								<!-- one or more weekdays -->
								<ng-select
									*ngSwitchCase="CRITERIA_TYPES.DAYS_OF_WEEK"
									[items]="dayOptions"
									bindLabel="label"
									bindValue="value"
									name="criterionDays{{categoryIndex}}_{{criteriaIndex}}"
									placeholder="{{'g.days_value' | translate}}"
									[multiple]="true"
									[readonly]="readonly"
									[ngClass]="{'border border-danger': detailError(categoryIndex, criteriaIndex, ['days'])}"
									[(ngModel)]="criterion.details.days"
									(ngModelChange)="emit()"
								></ng-select>

								<!-- the same calendar date every year -->
								<div *ngSwitchCase="CRITERIA_TYPES.FIXED_DATE" class="d-flex">
									<ng-select
										class="flex-grow-1 mr-1"
										[items]="monthOptions"
										bindLabel="label"
										bindValue="value"
										name="dateMonth{{categoryIndex}}_{{criteriaIndex}}"
										placeholder="{{'g.months_value' | translate}}"
										[clearable]="false"
										[readonly]="readonly"
										[ngClass]="{'border border-danger': detailError(categoryIndex, criteriaIndex, ['date','month'])}"
										[(ngModel)]="criterion.details.date.month"
										(ngModelChange)="resetDayForMonth(categoryIndex, criteriaIndex, 'date')"
									></ng-select>
									<ng-select
										class="flex-grow-1"
										[items]="monthsDays[criterion.details.date.month]"
										name="dateDay{{categoryIndex}}_{{criteriaIndex}}"
										placeholder="{{'g.days_value' | translate}}"
										[clearable]="false"
										[readonly]="readonly || !criterion.details.date.month"
										[ngClass]="{'border border-danger': detailError(categoryIndex, criteriaIndex, ['date','day'])}"
										[(ngModel)]="criterion.details.date.day"
										(ngModelChange)="emit()"
									></ng-select>
								</div>

								<!-- a numbered weekday of a month, e.g. the second Monday of March -->
								<div *ngSwitchDefault>
									<div class="d-flex" *ngIf="criterion.type && criterion.type !== CRITERIA_TYPES.YEAR">
										<ng-select
											class="flex-grow-1 mr-1"
											[items]="monthOptions"
											bindLabel="label"
											bindValue="value"
											name="ofMonth{{categoryIndex}}_{{criteriaIndex}}"
											placeholder="{{'g.months_value' | translate}}"
											[clearable]="false"
											[readonly]="readonly"
											[ngClass]="{'border border-danger': detailError(categoryIndex, criteriaIndex, ['month'])}"
											[(ngModel)]="criterion.details.month"
											(ngModelChange)="emit()"
										></ng-select>
										<ng-select
											class="flex-grow-1"
											[items]="dayOptions"
											bindLabel="label"
											bindValue="value"
											name="ofDay{{categoryIndex}}_{{criteriaIndex}}"
											placeholder="{{'g.days_value' | translate}}"
											[clearable]="false"
											[readonly]="readonly"
											[ngClass]="{'border border-danger': detailError(categoryIndex, criteriaIndex, ['day'])}"
											[(ngModel)]="criterion.details.day"
											(ngModelChange)="emit()"
										></ng-select>
									</div>

									<!-- a single year -->
									<ng-select
										*ngIf="criterion.type === CRITERIA_TYPES.YEAR"
										[items]="yearOptions"
										name="criterionYear{{categoryIndex}}_{{criteriaIndex}}"
										placeholder="{{'multi_tariff.categories.year' | translate}}"
										[clearable]="false"
										[readonly]="readonly"
										[ngClass]="{'border border-danger': detailError(categoryIndex, criteriaIndex, ['year'])}"
										[(ngModel)]="criterion.details.year"
										(ngModelChange)="emit()"
									></ng-select>
								</div>
							</td>
							<td>{{criterionDetailsText(criterion)}}</td>
							<td *ngIf="!readonly">
								<button
									type="button"
									class="btn btn-sm btn-link text-danger"
									(click)="removeCriterion(categoryIndex, criteriaIndex)"
								>
									{{'g.delete' | translate}}
								</button>
							</td>
						</tr>
					</tbody>
				</table>

				<button
					*ngIf="!readonly"
					type="button"
					class="btn btn-sm btn-outline-primary"
					[disabled]="category.criteria.length >= maxCriteria"
					(click)="addCriterion(categoryIndex)"
				>
					{{'multi_tariff.categories.add_criteria' | translate}}
				</button>
			</div>
		</div>

		<div *ngIf="!categories.length" class="text-muted">{{'g.no_data_available' | translate}}</div>
		<div *ngIf="!ratesOptions.length" class="text-muted mt-2">
			<small>{{'multi_tariff.rates.add_rate' | translate}}</small>
		</div>
	</div>
</div>
